import { render } from "./addedit.vue?vue&type=template&id=dfd17d70"
import script from "./addedit.vue?vue&type=script&lang=js"
export * from "./addedit.vue?vue&type=script&lang=js"

import exportComponent from "/builds/spsgn/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QItem,QInput,QBtn});
